import {
  FilterList as FilterIcon,
  KeyboardArrowDown as ArrowDownIcon,
} from "@mui/icons-material";
import { Button, Badge } from "@mui/material";
import React from "react";

import { useCelleraTheme } from "../../theme/useCelleraTheme";

interface FilterButtonProps {
  activeFiltersCount: number;
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
}

const FilterButton: React.FC<FilterButtonProps> = ({
  activeFiltersCount,
  onClick,
}) => {
  const { colors } = useCelleraTheme();

  return (
    <Badge
      color="primary"
      badgeContent={activeFiltersCount}
      invisible={activeFiltersCount === 0}
    >
      <Button
        variant="outlined"
        startIcon={<FilterIcon />}
        endIcon={<ArrowDownIcon />}
        onClick={onClick}
        sx={{
          p: "6px 24px",
          borderColor: colors.border.light,
          borderRadius: 1,
          color: colors.text.primary,
          "&:hover": {
            borderColor: colors.border.main,
            backgroundColor: colors.background.default,
          },
        }}
      >
        Filter
      </Button>
    </Badge>
  );
};

export default FilterButton;
